import './warning-popup.css'
import { MdClose } from 'react-icons/md'
import { MdWarningAmber } from 'react-icons/md'


const styles = {
    confirm: {
        icon: false,
        primaryButtonColor: '#334155'
    },
    warning: {
        icon: 'exclamation',
        primaryButtonColor: '#EF4444'
    }
}


const WarningPopup = ({ warningPopup }) => {
    const { type, title, message, onCancel, onConfirm } = warningPopup

    console.log(styles[type].primaryButtonColor)

    return (
        <div className='warning-popup__wrapper' id='warning-popup__wrapper' onClick={(e) => e.target.id === 'warning-popup__wrapper' && onCancel.action()}>
            <div className='warning-popup__modal'>
                <div className='warning-popup__modal__x-wrapper'>
                    <MdClose color='#D9D9D9' cursor={'pointer'} size={24} onClick={() => onCancel.action()} />
                </div>
                <div className='warning-popup__modal__title-section'>
                    { type === 'warning' && <div className='warning-popup__modal__title-section__icon-wrapper'>
                        <MdWarningAmber size={24} color={styles[type].primaryButtonColor} />
                    </div>}
                    <div className='warning-popup__modal__title-section__title'>{title}</div>
                </div>
                {type === 'confirm' && <div className='warning-popup__modal__decoration'></div>}
                <div className='warning-popup__modal__message-section'>{message}</div>
                <div className='warning-popup__modal__button-section'>
                    {onCancel && <button onClick={() => onCancel.action()} className='warning-popup__modal__button-section__cancel-button'>{onCancel.text}</button>}
                    {onConfirm && <button onClick={() => onConfirm.action()} style={{backgroundColor: styles[type].primaryButtonColor}} className='warning-popup__modal__button-section__confirm-button'>{onConfirm.text}</button>}
                </div>
            </div>
        </div>
    )
}
export default WarningPopup